import React, { useState, useEffect } from 'react';
import "./Chat.css";
import { Avatar, IconButton } from "@material-ui/core";
// import MoreVertIcon from "@material-ui/icons/MoreVert";
import { SearchOutlined, AttachFile, MoreVert } from "@material-ui/icons";
import InsertEmoticonIcon from "@material-ui/icons/InsertEmoticon";
import MicIcon from "@material-ui/icons/Mic";
import { useParams } from 'react-router-dom';
import db from './firebase';
import { useStateValue } from './StateProvider';
import firebase from "firebase";
import ScrollArea from "react-scrollbar";
// import ScrollToBottom from "react-scroll-to-bottom";
// import createEmotion from 'create-emotion'
// import { css } from 'emotion';

// const ROOT_CSS = css({
//     height: 100
//     // width: 400
// });


function Chat() {

    const [seed, setSeed] = useState("");
    const [input, setInput] = useState("");
    const { roomId } = useParams();
    const [roomName, setRoomName] = useState("");
    const [messages, setMessages] = useState([]);
    const [{ user }, dispatch] = useStateValue();



    useEffect(() => {
        if (roomId) {
            db.collection('rooms').doc(roomId).onSnapshot(snapshot => (
                setRoomName(snapshot.data().name)
            ));
            db.collection("rooms").doc(roomId).collection("messages").orderBy('timestamp', 'asc').onSnapshot(snapshot => (
                setMessages(snapshot.docs.map(doc => doc.data()))
            ))
        }

    }, [roomId])
    // depends on roomID

    const sendMessage = (e) => {
        e.preventDefault();
        // console.log("msg: ", input);
        db.collection('rooms').doc(roomId).collection('messages').add({
            message: input,
            name: user.displayName,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        })
        setInput("");
    };

    useEffect(() => {
        // a random number between 0 to 5000 to generate a dicebear avatar - human, bot,  grid/...
        setSeed(Math.floor(
            Math.random() * 5000
        ));
    }, [roomId])

    return (
        <div className="chat">
            {/* <h1>Chat</h1> */}
            <div className="chat__header">
                <Avatar src={`https://avatars.dicebear.com/api/gridy/${seed}.svg`} />

                <div className="chat__headerInfo">
                    <h3>{roomName}</h3>
                    <p>Last seen at {new Date(messages[messages.length - 1]?.timestamp?.toDate()).toUTCString()}</p>
                </div>

                <div className="chat__headerRight">
                    <IconButton>
                        <SearchOutlined />
                    </IconButton>
                    <IconButton>
                        <AttachFile />
                    </IconButton>
                    <IconButton>
                        <MoreVert />
                    </IconButton>

                </div>
            </div>


            {/* <ScrollArea speed={0.8}
                className="area"
                contentClassName="content"
                horizontal={true}  > */}

            <div className="chat__body"
            >
                {messages.map(message => (
                    // <ScrollToBottom className={ROOT_CSS}>

                    <p className={`chat__message ${message.name === user.displayName && 'chat__reciever'}`}>
                        <span className="chat__name">
                            {/* {message.name} */}
                            {message.name}
                        </span>
                        {message.message}
                        <span className="chat__timestamp">{new Date(message.timestamp?.toDate()).toUTCString()}</span>
                    </p>
                    // </ScrollToBottom>

                ))}
            </div>

            {/* </ScrollArea> */}



            <div className="chat__footer">

                <InsertEmoticonIcon />

                <form>
                    <input placeholder="Type your message ..." type="text" value={input} onChange={(e) => setInput(e.target.value)} />
                    <button onClick={sendMessage} type="submit">Send a message</button>
                </form>

                <MicIcon />

            </div>

        </div>
    )
}

export default Chat;
